/** Códigos de tipo de transacción PLD (alineado con Frontend/src/domain/Payment.js) */
const SIGLO_TRANSACTION_TYPES = [
  { id: '01', label: 'DEPOSITO' },
  { id: '02', label: 'RETIRO' },
  { id: '03', label: 'COMPRA DIVISAS' },
  { id: '04', label: 'VENTA DIVISAS' },
  { id: '05', label: 'CHEQUE DE CAJA' },
  { id: '06', label: 'GIROS' },
  { id: '07', label: 'ORDENES DE PAGO' },
  { id: '08', label: 'OTORGAMIENTO DE CREDITO' },
  { id: '09', label: 'PAGO DE CREDITO' },
  { id: '10', label: 'PAGO DE PRIMAS' },
  { id: '11', label: 'APORTACIONES A UN CONTRATO O FIDEICOMISO' },
  { id: '12', label: 'DEPOSITOS EN GARANTIA' },
  { id: '13', label: 'SALVAMENTOS' },
  { id: '14', label: 'DEPOSITO PATRONAL' },
  { id: '15', label: 'DEPOSITO DE TRABAJADOR' },
  { id: '16', label: 'PRESTAMO/CREDITO PARA COMPRA VALORES CON GARANTIA' },
  { id: '17', label: 'REPORTOS Y PRESTAMOS SOBRE VALORES' },
  { id: '18', label: 'COMPRA DE VALORES' },
  { id: '19', label: 'VENTA DE VALORES' },
  { id: '20', label: 'DEPOSITO DE APORTACION VOLUNTARIA' },
  { id: '21', label: 'DISP. EFECTIVO (TARJETA CREDITO O DEBITO)' },
  { id: '22', label: 'ALMACENAMIENTO DE BIENES O MERCANCIAS' },
  { id: '23', label: 'EMPAQUE Y ENVASADO DE BIENES Y MERCANCIAS' },
  { id: '24', label: 'GESTION DE GARANTIAS' },
  { id: '25', label: 'SERVICIOS DE DEPOSITO FISCAL' },
  { id: '26', label: 'CONTRATACION DE ARRENDAMIENTO FINANCIERO' },
  { id: '27', label: 'PAGO DE RENTAS DE ARRENDAMIENTO FINANCIERO' },
  { id: '28', label: 'VENTA DE BIENES ARRENDADOS' },
  { id: '29', label: 'ADQUISICION DE BIENES DEL FUTURO ARRENDATARIO' },
  { id: '30', label: 'RECEPCION DE PRESTAMOS' },
  { id: '31', label: 'ADQUISICION DE DOCUMENTOS' },
  { id: '32', label: 'CONTRATACION, CONSTRUCCION O ADMINISTRACION DE OBRAS' },
  { id: '33', label: 'PROMOCION DE ORGANIZACIÓN Y ADMINISTRACION DE EMPRESAS' },
  { id: '34', label: 'COMPRA VENTA DE FRUTOS O PRODUCTOS' },
  { id: '35', label: 'CONTRATOS DE FACTORAJE FINANCIERO' },
  { id: '36', label: 'SERVICIOS DE ADMINISTRACION Y  COBRANZA DE CREDITOS' },
];

export default SIGLO_TRANSACTION_TYPES;
